'use strict';
import product from './pages/product';
import util from './util';
import modal from './modal';
import variant from './pages/product/redesign/variant';
import images from './pages/product/image';
import _ from 'lodash-es';
import customModal from './modal';
import reinsuranceCheckout from './pages/reinsuranceCheckout';

const { global: modalGlobal } = modal;
var makeUrl = function (url, source, productListID, upsell) {

	if (upsell) {
		url = util.appendParamToURL(url, 'upsell', upsell);
	}

	if (source) {
		url = util.appendParamToURL(url, 'source', source);
	}
	if (productListID) {
		url = util.appendParamToURL(url, 'productlistid', productListID);
	}
	return url;
};

var removeParam = function (url) {
	if (url.indexOf('?') !== -1) {
		return url.substring(0, url.indexOf('?'));
	} else {
		return url;
	}
};
var updateQuickviewScroll = function () {
	$('.quickview-modal .modal-body').scrollBox();
};

function renderThumbnails() {
	if ($('#thumbnails').length > 0) {
		$('#pdp-thumbnails-image').empty(); // clear the list
		images(); // populate the thumbnails
	}
};
var quickview = {
	init: function () {
		if (!this.exists()) {
			this.$container = $('<div/>').attr('id', 'QuickViewDialog').appendTo(document.body);
		}
		this.productLinks = $('#search-result-items .thumb-link').map(function (index, thumbLink) {
			return $(thumbLink).attr('href');
		});
		
		$(document).on('click', '.reinsurance-wrapper', function (e) {
			$(this).find('.reinsuranceDesc').toggleClass('open');
			$(this).find('.plus-icon').toggleClass('hide');
			$(this).find('.minus-icon').toggleClass('show');
			$(this).siblings().toggleClass('hidden');
			$(this).find('.reinsurance-content').toggleClass('adjust-margin-content');
			$(this).toggleClass('reinsurance-margin');
		});

	},

	setup: function (qvUrl) {
		var $btnNext = $('.quickview-next'),
			$btnPrev = $('.quickview-prev');

		product.initializeEvents();

		this.productLinkIndex = _(this.productLinks).findIndex(function (url) {
			return removeParam(url) === removeParam(qvUrl);
		});

		// hide the buttons on the compare page or when there are no other products
		if (this.productLinks.length <= 1 || $('.compareremovecell').length > 0) {
			$btnNext.hide();
			$btnPrev.hide();
			return;
		}

		if (this.productLinkIndex === this.productLinks.length - 1) {
			$btnNext.attr('disabled', 'disabled');
		}
		if (this.productLinkIndex === 0) {
			$btnPrev.attr('disabled', 'disabled');
		}

		$btnNext.on('click', function (e) {
			e.preventDefault();
			this.navigateQuickview(1);
		}.bind(this));
		$btnPrev.on('click', function (e) {
			e.preventDefault();
			this.navigateQuickview(-1);
		}.bind(this));
	},

	/**
	 * @param {Number} step - How many products away from current product to navigate to. Negative number means navigate backward
	 */
	navigateQuickview: function (step) {
		// default step to 0
		//this.productLinkIndex += (step ? step : 0);
		//var url = makeUrl(this.productLinks[this.productLinkIndex], 'quickview');
	},

	/**
	 * @description show quick view dialog
	 * @param {Object} options
	 * @param {String} options.url - url of the product details
	 * @param {String} options.source - source of the dialog to be appended to URL
	 * @param {String} options.productlistid - to be appended to URL
	 * @param {Function} options.callback - callback once the dialog is opened
	 */
	show: function (options) {
		var url = makeUrl(options.url, options.source, options.productlistid, options.upsell),
			windowScrollPosition = $(window).scrollTop();

		url = util.appendParamToURL(url, 'format', 'ajax');
		$.ajax({
			url: url,
			dataType: 'html',
			success: function (response) {
				customModal.createCustomModal('quickview-modal', '#modal-custom-placeholder');
				$('.quickview-modal .modal-body').html(response);
				$('.quickview-modal select').selectmenu({
					classes: {
						"ui-selectmenu-menu": "qv-select"
					}
				});
				$('.add-to-cart-in-stock select#quantity').selectmenu({
					position: {
						my: "top",
						at: "top",
						collision: "none"
					}
				});
			}
		}).done(function (data) {
			variant();
			renderThumbnails();
			updateQuickviewScroll();
			reinsuranceCheckout.reinsurancePanelHandlerPdp();
			if (navigator.userAgent.match(/(iPhone|iPad)/)) {
				$('body').addClass('body-fixed');
				$('.quickview-modal .modal-close, .quickview-modal .modal-close-outer').off('click').on('click', function () {
					$('quickview-modal').remove();
					$('body').removeClass('body-fixed');
					$('html').removeClass('modal-open');
					$(window).scrollTop(windowScrollPosition);
				});
			}
			// Enable the add-to-cart button
			if ($('.disabled-onload') && $('.disabled-onload').length > 0){
				$('.disabled-onload').removeClass('disabled-onload');
			}
			
			$(document).ready(function() { 
				$('.reinsurance-wrapper').each(function() {
					if ($(this).find('.reinsuranceDesc').length === 0) {
					  $(this).find('.description-icon').addClass('hide');
					  $(this).find('.reinsurance-content svg').addClass('remove-svg-margin');
					  $(this).css("cursor", "default");
					  $(this).prop("disabled", true);
					}
				});
			});
		});
	},
	exists: function () {
		return this.$container && (this.$container.length > 0);
	}
};

export default quickview;